export default (initialTab = null) => ({
    currentTab: initialTab,
    onOpen(event) {
        this.currentTab = event.detail;
    },
    onClose() {
        this.currentTab = null
    },
    init() {

    }
});